import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-layout',
  templateUrl: './gas-icon-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconLayoutComponent { }
